module.exports = __webpack_public_path__ + "static/media/6_r_rim_92.19_30.46.7f32d27d.png";